import { amIImpersonating, EStorageType, getStorage, setStorage, TColors, TEmailReport, TemplateModel } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { affixToPercent, logError } from "../data"
import { TGetComparedStat, TGetCurrentStoredFilters, TValidateSystemEmailContentReturn } from "./types"
import { ESystemEmailType } from "../../components/systemEmails/tableListing/types"
import { TIconName } from "@cakemail-org/ui-components-v2/dist/esm/components/icon/types"

export function getCurrentStoredFilters<A>({ getFullStorage, key, storageType, accountId }: TGetCurrentStoredFilters): Partial<A> {
    const storedFilters: A = getStorage({ key: key, type: storageType || EStorageType.session }) || {}
    if (getFullStorage)
        return storedFilters

    if (!accountId) {
        logError("An Account id is required to get storred filters", { key, storageType })
        return {}
    }
    //@ts-ignore
    return storedFilters?.[amIImpersonating(true)] || storedFilters?.[String(accountId)] || {}
}

export function setCurrentStoredFilters<A>({ key, accountId, data }: { key: string, accountId: number, data: A }) {
    const currentStoredFilters: any = getCurrentStoredFilters({ key, getFullStorage: true })

    const cAccountId = amIImpersonating(true) || accountId

    setStorage({
        key,
        data: {
            ...currentStoredFilters,
            [cAccountId]: data
        },
        type: EStorageType.session
    })
}


export function validateSystemEmailContent({ template, systemEmailType }: { template: TemplateModel, systemEmailType: ESystemEmailType }): TValidateSystemEmailContentReturn {
    const content: string = template.content.type === "bee" ? JSON.stringify(template.content.json) : String(template.content.html)
    let requiredMergeTags

    switch (systemEmailType) {
        case ESystemEmailType.accountConfirm:
            requiredMergeTags = [{
                value: "[CLIENT.CONFIRMATION]",
                msg: t("system-emails-req-tag-client-confirmation")
            }]
            break
        case ESystemEmailType.contactDOptIn:
            requiredMergeTags = [{
                value: "[CONFIRM_LINK]",
                msg: t("system-emails-req-tag-contact-confirmation")
            }]
            break
        case ESystemEmailType.passwordReset:
            requiredMergeTags = [{
                value: "[RESET_PASSWORD_LINK]",
                msg: t("system-emails-req-tag-password-reset")
            }]
            break
        case ESystemEmailType.senderConfirm:
            requiredMergeTags = [{
                value: "[SENDER.CONFIRMATION_LINK]",
                msg: t("system-emails-req-tag-sender-confirmation")
            }]
            break
        case ESystemEmailType.userConfirm:
            requiredMergeTags = [{
                value: "[USER.CONFIRMATION]",
                msg: t("system-emails-req-tag-user-confirmation")
            }]

            break
    }

    const missingTags: TValidateSystemEmailContentReturn = []

    requiredMergeTags.forEach((tag) => {
        if (!content.includes(tag.value)) {
            missingTags.push(tag)
        }
    })

    return missingTags.length > 0 ? missingTags : undefined
}


export function getComparedReportStat<T>({ metrics, oldMetrics, stat, isRate, reverse }: TGetComparedStat<T>): { icon?: TIconName, value: string, color: TColors } | undefined {
    if (metrics && oldMetrics) {
        let mainM: number = 0
        let secondM: number = 0

        mainM = Number(metrics[stat])
        secondM = Number(oldMetrics[stat])

        let total = mainM
        if (total !== 0) {
            total = isRate ? mainM - secondM : (mainM - secondM) / Math.max(mainM, secondM) * 100
        }

        let colorComparator = total === 0 ? null : (reverse ? total < 0 : total > 0)

        return {
            icon: total === 0 ? undefined : total > 0 ? "ArrowUp10" : "ArrowDown10",
            value: affixToPercent(total),
            color: colorComparator === null ? "boulder" : colorComparator ? "secondary" : "warning"
        }
    }

    return
}